import React from 'react';

import { ShareableLinkSiteAdminControlsLoader } from '@confluence/access-links/entry-points/ShareableLinkSiteAdminControlsLoader.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminShareableLinksRoute = () => <ShareableLinkSiteAdminControlsLoader />;

AdminShareableLinksRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'siteSettingsAccessLinksScreen' },
	},
	sideNavigationId: ADMIN_HOME_ID,
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
